import React from 'react';

type CardIconProps = {
  brand: string;
  size?: string;
  color?: string;
};

const CardIcon: React.FC<CardIconProps> = ({
  brand,
  size = '30px',
  color = '#1a73e8'
}) => {
  const getBrandSvg = () => {
    const commonProps = {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: color,
    };

    switch (brand) {
      case 'visa':
        return (
          <svg
            {...commonProps}
            viewBox="0 0 32 32"
          >
            <path d="M15.854 11.329l-2.003 9.367h-2.424l2.006-9.367zM26.051 17.377l1.275-3.518 0.735 3.518zM28.754 20.696h2.242l-1.956-9.367h-2.069c-0.003-0-0.007-0-0.010-0-0.459 0-0.853 0.281-1.019 0.68l-0.003 0.007-3.635 8.68h2.544l0.506-1.4h3.109zM22.429 17.638c0.010-2.473-3.419-2.609-3.395-3.714 0.008-0.336 0.327-0.694 1.027-0.785 0.13-0.013 0.28-0.021 0.432-0.021 0.711 0 1.385 0.162 1.985 0.452l-0.027-0.012 0.425-1.987c-0.673-0.261-1.452-0.413-2.266-0.416h-0.001c-2.396 0-4.081 1.275-4.096 3.098-0.015 1.348 1.203 2.099 2.122 2.549 0.945 0.459 1.262 0.754 1.257 1.163-0.006 0.63-0.752 0.906-1.45 0.917-0.032 0.001-0.071 0.001-0.109 0.001-0.871 0-1.691-0.219-2.407-0.606l0.027 0.013-0.439 2.052c0.786 0.315 1.697 0.497 2.651 0.497 0.015 0 0.030-0 0.045-0h-0.002c2.546 0 4.211-1.257 4.22-3.204zM12.391 11.329l-3.926 9.367h-2.562l-1.932-7.477c-0.037-0.364-0.26-0.668-0.57-0.82l-0.006-0.003c-0.688-0.338-1.488-0.613-2.325-0.786l-0.066-0.011 0.058-0.271h4.124c0 0 0.001 0 0.001 0 0.562 0 1.028 0.411 1.115 0.948l0.001 0.006 1.021 5.421 2.522-6.376z" />
          </svg>
        );

      case 'mastercard':
        return (
          <svg {...commonProps}>
            <circle cx="9" cy="12" r="5" fill="#eb001b" />
            <circle cx="15" cy="12" r="5" fill="#f79e1b" />
            <path d="M12 8.5a4.99 4.99 0 0 0 0 7 4.99 4.99 0 0 0 0-7z" fill="#ff5f00" />
          </svg>
        );

      case 'amex':
        return (
          <svg {...commonProps}>
            <path d="M3 8.5h2.5l.5 1 .5-1H9v4.5l1.5-4.5h2l1.5 4.5V8.5h2.5l.5 1 .5-1H21v7H3v-7z" />
            <path d="M6.5 11.5h-2v-.5h2v.5zm0 1h-2v-.5h2v.5z" />
            <path d="M16.5 11.5h2v-.5h-2v.5zm0 1h2v-.5h-2v.5z" />
          </svg>
        );

      case 'jcb':
        return (
          <svg {...commonProps}>
            <rect x="3" y="8" width="5" height="8" rx="1" fill="#0066b2" />
            <rect x="9.5" y="8" width="5" height="8" rx="1" fill="#c00" />
            <rect x="16" y="8" width="5" height="8" rx="1" fill="#5cb85c" />
          </svg>
        );

      case 'discover':
        return (
          <svg {...commonProps}>
            <path d="M3 10c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-4z" />
            <circle cx="19" cy="12" r="2" fill="#ff6000" />
          </svg>
        );

      case 'diners-club':
        return (
          <svg {...commonProps}>
            <circle cx="12" cy="12" r="7" fill="none" stroke={color} strokeWidth="1" />
            <path d="M9 8c-1.657 0-3 1.79-3 4s1.343 4 3 4V8zm6 8c1.657 0 3-1.79 3-4s-1.343-4-3-4v8z" />
          </svg>
        );

      case 'paypal':
        return (
          <svg {...commonProps}>
            <path d="M8.059 14.738c-.165.874-.793 1.262-1.608 1.262H5.604l.463-2.935c.028-.177.18-.311.36-.311h.302c.788 0 1.533 0 1.918-.449.228-.267.31-.663.252-1.213-.122-1.161-1.064-1.092-1.995-1.092H4.8c-.36 0-.669.267-.726.629l-1.07 6.775c-.042.265.166.504.435.504h1.508l.378-2.396.463-2.935h1.152c.627 0 1.219-.02 1.735-.297.674-.362 1.06-1.019 1.146-1.953.157-1.7-1.096-2.565-2.86-2.565H4.307c-.36 0-.669.267-.726.629L2.51 16.371c-.042.265.166.504.435.504h2.513c.72 0 1.338-.518 1.479-1.237l.122-.774z" />
            <path d="M17.06 14.738c-.165.874-.793 1.262-1.608 1.262h-.847l.463-2.935c.028-.177.18-.311.36-.311h.302c.788 0 1.533 0 1.918-.449.228-.267.31-.663.252-1.213-.122-1.161-1.064-1.092-1.995-1.092h-2.104c-.36 0-.669.267-.726.629l-1.07 6.775c-.042.265.166.504.435.504h1.508l.378-2.396.463-2.935h1.152c.627 0 1.219-.02 1.735-.297.674-.362 1.06-1.019 1.146-1.953.157-1.7-1.096-2.565-2.86-2.565h-3.654c-.36 0-.669.267-.726.629l-1.071 6.775c-.042.265.166.504.435.504h2.513c.72 0 1.338-.518 1.479-1.237l.122-.774z" opacity=".7" />
          </svg>
        );

      case 'stripe':
        return (
          <svg {...commonProps} viewBox="0 0 24 24">
            <path d="M13.976 9.15c-2.172-.806-3.356-1.426-3.356-2.409 0-.831.683-1.305 1.901-1.305 2.227 0 4.515.858 6.09 1.631l.89-5.494C18.252.975 15.697 0 12.165 0 9.667 0 7.589.654 6.104 1.872 4.56 3.147 3.757 4.992 3.757 7.218c0 4.039 2.467 5.76 6.476 7.219 2.585.92 3.445 1.574 3.445 2.583 0 .98-.84 1.545-2.354 1.545-1.875 0-4.965-.921-6.99-2.109l-.9 5.555C5.175 22.99 8.385 24 11.714 24c2.641 0 4.843-.624 6.328-1.813 1.664-1.305 2.525-3.236 2.525-5.732 0-4.128-2.524-5.851-6.594-7.305h.003z" />
          </svg>
        );

      case 'apple-pay':
        return (
          <svg {...commonProps} viewBox="0 0 24 24">
            <path d="M5.624 14.924c-.446 0-.887-.12-1.274-.347a2.404 2.404 0 0 1-.908-1.003 2.4 2.4 0 0 1-.186-1.354c.09-.455.316-.87.654-1.2.338-.33.764-.548 1.232-.63.468-.082.952-.024 1.398.167.446.19.824.504 1.092.906.268.402.412.87.416 1.35v.024c-.003.642-.263 1.257-.723 1.71a2.48 2.48 0 0 1-1.7.677zm7.274-4.86c-.656 0-1.29.25-1.76.698-.47.448-.733 1.056-.733 1.69s.263 1.242.733 1.69c.47.448 1.104.698 1.76.698s1.29-.25 1.76-.698c.47-.448.733-1.056.733-1.69s-.263-1.242-.733-1.69c-.47-.448-1.104-.698-1.76-.698z" />
            <path d="M12.315 5.36c.308-.373.467-.838.447-1.31-.464.047-.91.248-1.253.566-.343.318-.55.742-.582 1.193.48.018.947-.146 1.308-.45h.08z" />
          </svg>
        );

      case 'amazon-pay':
        return (
          <svg {...commonProps} viewBox="0 0 24 24">
            <path d="M14.93 12.5c-1.04.55-2.43.85-3.67.85-1.74 0-3.3-.64-4.48-1.7-.1-.08-.01-.2.1-.14 1.29.75 2.89 1.2 4.54 1.2 1.11 0 2.34-.23 3.46-.71.17-.07.31.11.15.24l-.1.06zm.82-.93c-.13-.17-.87-.08-1.2-.04-.1.01-.12-.08-.03-.14.59-.41 1.55-.29 1.66-.15.11.14-.03 1.12-.59 1.59-.09.07-.17.04-.13-.06.12-.3.39-.98.26-1.15l.03-.05z" />
            <path d="M13.52 9.48c-.38-.49-.73-.9-.73-1.82V7.5c0-1.54.02-2.95-1.15-4-.95-.9-2.53-1.22-3.75-1.22-2.36 0-5 .88-5.55 3.8-.06.31.17.48.37.52l2.57.28c.24-.01.41-.25.46-.49.21-1.07.88-1.6 1.71-1.6.44 0 .93.16 1.19.55.3.44.26.04.26 1.48v.27c-1.45.17-3.34.28-4.65.86-1.5.66-2.55 2.01-2.55 3.98 0 2.53 1.59 3.79 3.64 3.79.73 0 1.38-.09 2.04-.48.77-.48 1.33-1.23 1.82-2.01.31.72.41 1.07.98 1.9.13.11.3.1.44 0 .57-.47 1.6-1.38 2.17-1.86.14-.12.12-.32 0-.5l.01.01zm-3.47.01v.69c0 1.14.03 2.09-.55 3.1-.47.82-1.22 1.32-2.05 1.32-1.14 0-1.8-.86-1.8-2.14 0-2.52 2.25-2.97 4.39-2.97h.01z" />
          </svg>
        );

      default:
        return (
          <svg {...commonProps}>
            <rect x="3" y="6" width="18" height="12" rx="2" fill="none" stroke={color} strokeWidth="2" />
            <path d="M3 10h18" stroke={color} strokeWidth="2" />
            <rect x="5" y="13" width="4" height="2" rx="0.5" />
          </svg>
        );
    }
  };

  return getBrandSvg();
};

export default CardIcon;
